import clsx from 'clsx'
import { ChangeEventHandler, FormEvent } from 'react'

import { HeaderSearchInput } from '@/widgets/Header/ui/header-search-input/header-search-input'

import { useGetPromptQuery } from '@/features/search/api/search.api'
import { useTypewriterEffect } from '@/features/search/hooks/use-typewriter-effect'

import { Icon } from '@/shared/ui/icon'

import cl from './style.module.scss'

interface SearchInputProps {
	onChange: ChangeEventHandler<HTMLInputElement>
	value: string
	onReset: () => void
	onSubmit: (event: FormEvent<HTMLFormElement>) => void
}

export const HeaderSearchForm = (props: SearchInputProps) => {
	const { value, onChange, onSubmit, onReset } = props

	const { data: promptData, isError, error } = useGetPromptQuery()

	if (isError) console.error('[HEADER SEARCH FORM] Error loading prompts:', error)

	const effectivePrompts = promptData ?? []

	const promptText = useTypewriterEffect(effectivePrompts)

	return (
		<form className={cl.root} onSubmit={onSubmit}>
			<div className={cl.wrapper}>
				<div className={clsx(cl.icon, cl.icon_search)}>
					<Icon name={'Search'} />
				</div>
				<HeaderSearchInput value={value} onChange={onChange} placeholder={promptText} />
				{value && (
					<button className={cl.button} type={'button'} onClick={onReset}>
						<Icon name={'Close'} />
					</button>
				)}
			</div>
		</form>
	)
}
